import './PdfReportType.css';

import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledAvatar = styled(Box)(({ theme, selected, size }) => ({
    width: size,
    height: size,
    border: selected ? `2px solid ${theme.palette.primary.main}` : 'none',
    cursor: 'pointer',
    placeSelf: 'center',

    borderRadius: '10px', 
    overflow: 'hidden', // Ensure the image does not overflow the container
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
}));

const PdfReportType = ({ alt, src, selected, size, label, onClick }) => {
    return (
        <Box textAlign="center" onClick={onClick} className="pdf-report-type">
            <StyledAvatar selected={selected} size={size}>
                <img
                    alt={alt}
                    src={src}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }}
                />
            </StyledAvatar>
            <Typography 
                variant="caption" 
                sx={{ 
                    fontFamily: 'Lexend', 
                    fontSize: '12px', 
                    wordBreak: 'break-word', 
                    whiteSpace: 'normal' 
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};

export default PdfReportType;